import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Navigate, useParams } from 'react-router-dom';
import useNavigation from '@hooks/useNavigation.tsx';

/**
 * @deprecated Legacy customer expedition detail page. Anyone landing here is redirected to the
 * expedition list, with the route `id` applied as the applicationId filter.
 */
const CustomerExpeditionDetailPage = () => {
  const { id } = useParams();
  const nav = useNavigation();

  return <Navigate to={nav.createNavigationLink(nav.urlFunctions.createCustomerExpeditionList(id ? { applicationId: id } : undefined))} replace />;
};

export default withAuthenticationRequired(CustomerExpeditionDetailPage);